import './WhoisPage.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { Box } from '../Box';
import { Button } from '../Button';
import { Container } from '../Container';
import { WhoisPageContentType } from '../contentTypes';
import { t } from '../i18n/i18n';
import { Page } from './Page';

export interface WhoisPageProps {}

export const WhoisPage = (props: WhoisPageProps) => {
  const [register, setRegister] = React.useState<boolean>(false);

  const handleButtonClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setRegister(true);
  }, []);

  const handleCancelButtonClick = React.useCallback(() => {
    console.log('cancel click');
    setRegister(false);
  }, []);
  const whoisContent = b2x.useContent<WhoisPageContentType>('WHOIS_PAGE_CONTENT');

  const navigate = b2x.router.useNavigate();

  const handleLoginSuccess = React.useCallback(() => {
    navigate('/checkout');
  }, [navigate]);

  const handleRegistrationSuccess = React.useCallback(() => {
    navigate('/checkout');
  }, [navigate]);

  return (
    <Page
      backgroundAsset={whoisContent?.body.asset}
      backgroundSize="cover"
      className="whois-page"
      headerCheckout
      noPaddingTop
    >
      <div className="mt-5 pt-3 h-100 d-flex items-center">
        <Container>
          <b2x.Row className="justify-content-center">
            <b2x.Col size={{ md: 6, xl: 5, xs: 12 }}>
              <Box className="whois-box text-white" fullHeight>
                <div className="border-bottom mb-3 border-gray-200">
                  <h3 className="text-center text-uppercase fw-medium letter-spacing-md">
                    {b2x.formatHtml(whoisContent?.body.continueAsRegisteredUser?.title)}
                  </h3>
                </div>
                <div className="mb-4 fw-light text-center">
                  {b2x.formatHtml(whoisContent?.body.continueAsRegisteredUser?.subTitle)}
                </div>
                <b2x.LoginForm onSuccess={handleLoginSuccess} />
              </Box>
            </b2x.Col>
            <b2x.Col size={{ md: 6, xl: 5, xs: 12 }}>
              <Box className="whois-box text-white mt-3 mt-md-0">
                {!register && (
                  <>
                    <div className="mb-lg-5 mb-4">
                      <div className="border-bottom mb-3 border-gray-200">
                        <h3 className="text-center text-uppercase fw-medium letter-spacing-md">
                          {b2x.formatHtml(whoisContent?.body.continueAsGuest?.title)}
                        </h3>
                      </div>
                      <div className="mb-3 text-center fw-light">
                        {b2x.formatHtml(whoisContent?.body.continueAsGuest?.registerMe?.content)}
                      </div>
                      <div className="d-grid">
                        <Button
                          className="fw-light"
                          label={t('misc.register')}
                          onClick={handleButtonClick}
                          variant="outline-secondary"
                        />
                      </div>
                    </div>
                    <div
                      className="h5 text-center fw-bold pb-4 pt-lg-5 pt-4 text-uppercase"
                      style={{ textWrap: 'balance' }}
                    >
                      {b2x.formatHtml(whoisContent?.body.continueAsGuest?.subTitle)}
                    </div>
                    <b2x.CartEmailFormHelper variant="whois">
                      {({ fieldsHelper, formik }) => (
                        <>
                          <b2x.FormGroup {...fieldsHelper.email.formGroup}>
                            <b2x.TextInput {...fieldsHelper.email.textInput} />
                          </b2x.FormGroup>
                          <b2x.FormGroup {...fieldsHelper.privacy.formGroup}>
                            <b2x.Checkbox className="extra-small fw-light" {...fieldsHelper.privacy.checkbox} />
                          </b2x.FormGroup>
                          <div className="d-grid">
                            <b2x.Button
                              className="fw-light"
                              {...fieldsHelper.buttons.submit}
                              variant="outline-secondary"
                            />
                          </div>
                        </>
                      )}
                    </b2x.CartEmailFormHelper>
                  </>
                )}
                {register && (
                  <div className="mb-4">
                    <h3 className="text-center text-uppercase fw-medium letter-spacing-md mb-3">
                      {b2x.formatHtml(whoisContent?.body.continueAsGuest?.title)}
                    </h3>
                    <b2x.CustomerForm onCancel={handleCancelButtonClick} onSuccess={handleRegistrationSuccess} />
                  </div>
                )}
              </Box>
            </b2x.Col>
          </b2x.Row>
        </Container>
      </div>
    </Page>
  );
};
